// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__mQ5Ij","pagination":"Pagination_pagination__NHg5T","prevArrow":"Pagination_prevArrow__c2ziU","nextArrow":"Pagination_nextArrow__IO6Pg"};